export default "__VITE_ASSET__BIaI4u2v__";